import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import * as Icons from "@bw/icons"

const Wrapper = styled.span`
  display: flex;
  font-weight: 400;
  font-size: 17px;
  line-height: 152.9%;
  color: var(--page-color);
  font-family: "Ginto";
  margin-top: 38px;
  > * {
    margin-right: 14px;
  }
`

const Delivery = ({ title }) => {
  return (
    <>
      {title && (
        <Wrapper>
          <Icons.Delivery />
          {title}
        </Wrapper>
      )}
    </>
  )
}

Delivery.propTypes = {
  title: PropTypes.string,
}

export { Delivery }
